import { AccessTime } from '@mui/icons-material'
import { Box, Chip, Grid, Paper, Typography } from '@mui/material'

const MoratoriumData = ({ loanData }: { loanData: any }) => {
    return (
        <Grid item xs={12}>
            <Paper
                elevation={2}
                sx={{
                    p: 3,
                    backgroundColor: '#F0F9FF',
                    border: '2px solid #E1F5FE',
                    borderRadius: 2,
                    mt: 2,
                    mb:3
                }}
            >
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <AccessTime color="primary" />
                    <Typography variant="h6" color="primary.main" fontWeight="600">
                        Moratorium Details
                    </Typography>
                </Box>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            Moratorium Period
                        </Typography>
                        <Typography variant="h6" color="text.primary" fontWeight="600">
                            {loanData.moratoriumMonths} months
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            Moratorium Start
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            {loanData.moratoriumStartDate ?
                                new Date(loanData.moratoriumStartDate).toLocaleDateString() :
                                'Not set'
                            }
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            EMI Starts From
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            {loanData.effectiveLoanStartDate ?
                                new Date(loanData.effectiveLoanStartDate).toLocaleDateString() :
                                'After moratorium'
                            }
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            Status
                        </Typography>
                        <Chip
                            label="Active Moratorium"
                            color="warning"
                            size="small"
                            variant="outlined"
                        />
                    </Grid>
                </Grid>

                <Box mt={2}>
                    <Typography variant="caption" color="text.secondary">
                        💡 No EMI payments or interest will be charged during the moratorium period.
                        Regular repayments will begin after {loanData.moratoriumMonths} months.
                    </Typography>
                </Box>
            </Paper>
        </Grid>
    )
}

export default MoratoriumData